import React, { lazy, Suspense } from 'react';

const LazyWarrantyClaimForm = lazy(() => import('./WarrantyClaimForm'));

const WarrantyClaimForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyWarrantyClaimForm {...props} />
  </Suspense>
);

export default WarrantyClaimForm;
